// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"565":"6a7a2541","787":"aafde3b1"}[chunkId] + ".chunk.js";
};